const a = {
  addToFolder: () => import("./index28.mjs"),
  addedtoFolder: () => import("./index29.mjs"),
  alarmBell: () => import("./index30.mjs"),
  alignBottom: () => import("./index31.mjs"),
  alignCenter: () => import("./index32.mjs"),
  alignLeft: () => import("./index33.mjs"),
  alignMiddle: () => import("./index34.mjs"),
  alignRight: () => import("./index35.mjs"),
  alignTop: () => import("./index36.mjs"),
  amex: () => import("./index37.mjs"),
  applePay: () => import("./index38.mjs"),
  arrowBack: () => import("./index39.mjs"),
  arrowCursorBlue: () => import("./index40.mjs"),
  arrowCursorPink: () => import("./index41.mjs"),
  arrowCursorYellow: () => import("./index42.mjs"),
  arrowDown: () => import("./index43.mjs"),
  arrowRight: () => import("./index44.mjs"),
  arrowUp: () => import("./index45.mjs"),
  attachment: () => import("./index46.mjs"),
  audioModified: () => import("./index47.mjs"),
  blankCalendarBlue: () => import("./index48.mjs"),
  blankCalendarPink: () => import("./index49.mjs"),
  blankCalendarYellow: () => import("./index50.mjs"),
  brain: () => import("./index51.mjs"),
  businessStartupBlue: () => import("./index52.mjs"),
  businessStartupPink: () => import("./index53.mjs"),
  businessStartupYellow: () => import("./index54.mjs"),
  calendar: () => import("./index55.mjs"),
  cameraBlue: () => import("./index56.mjs"),
  cameraPink: () => import("./index57.mjs"),
  cameraYellow: () => import("./index58.mjs"),
  cameraVideoBlue: () => import("./index59.mjs"),
  cameraVideoPink: () => import("./index60.mjs"),
  cameraVideoYellow: () => import("./index61.mjs"),
  chatBubbleTypingOvalBlue: () => import("./index62.mjs"),
  chatBubbleTypingOvalPink: () => import("./index63.mjs"),
  chatBubbleTypingOvalYellow: () => import("./index64.mjs"),
  chatTwoBubblesSquareBlue: () => import("./index65.mjs"),
  chatTwoBubblesSquarePink: () => import("./index66.mjs"),
  chatTwoBubblesSquareYellow: () => import("./index67.mjs"),
  check: () => import("./index68.mjs"),
  checkCircle: () => import("./index69.mjs"),
  chevronDown: () => import("./index70.mjs"),
  chevronLeft: () => import("./index71.mjs"),
  chevronRight: () => import("./index72.mjs"),
  chevronUp: () => import("./index73.mjs"),
  circleClockBlue: () => import("./index74.mjs"),
  circleClockPink: () => import("./index75.mjs"),
  circleClockYellow: () => import("./index76.mjs"),
  close: () => import("./index77.mjs"),
  cog: () => import("./index78.mjs"),
  compass: () => import("./index79.mjs"),
  controlsForward: () => import("./index80.mjs"),
  controlsPause: () => import("./index81.mjs"),
  controlsPlay: () => import("./index82.mjs"),
  controlsRecord: () => import("./index83.mjs"),
  controlsRewind: () => import("./index84.mjs"),
  controlsStop: () => import("./index85.mjs"),
  dashboardGaugeBlue: () => import("./index86.mjs"),
  dashboardGaugePink: () => import("./index87.mjs"),
  dashboardGaugeYellow: () => import("./index88.mjs"),
  dinersClub: () => import("./index89.mjs"),
  discover: () => import("./index90.mjs"),
  downloadBottom: () => import("./index91.mjs"),
  downloadSquareBlue: () => import("./index92.mjs"),
  downloadSquarePink: () => import("./index93.mjs"),
  downloadSquareYellow: () => import("./index94.mjs"),
  dropbox: () => import("./index95.mjs"),
  emptyClipboardBlue: () => import("./index96.mjs"),
  emptyClipboardPink: () => import("./index97.mjs"),
  emptyClipboardYellow: () => import("./index98.mjs"),
  erlenmeyerFlaskBlue: () => import("./index99.mjs"),
  erlenmeyerFlaskPink: () => import("./index100.mjs"),
  erlenmeyerFlaskYellow: () => import("./index101.mjs"),
  error: () => import("./index102.mjs"),
  expandHorizontal: () => import("./index103.mjs"),
  expandVertical: () => import("./index104.mjs"),
  facebook: () => import("./index105.mjs"),
  favorite: () => import("./index106.mjs"),
  favoriteFilled: () => import("./index107.mjs"),
  fileDouble: () => import("./index108.mjs"),
  filter: () => import("./index109.mjs"),
  filterImage: () => import("./index110.mjs"),
  filterMusic: () => import("./index111.mjs"),
  filterPlus: () => import("./index112.mjs"),
  filterVideo: () => import("./index113.mjs"),
  folderStar: () => import("./index114.mjs"),
  gitHub: () => import("./index115.mjs"),
  googlePay: () => import("./index116.mjs"),
  graphPieChartBlue: () => import("./index117.mjs"),
  graphPieChartPink: () => import("./index118.mjs"),
  graphPieChartYellow: () => import("./index119.mjs"),
  gridRulesBlue: () => import("./index120.mjs"),
  gridRulesPink: () => import("./index121.mjs"),
  gridRulesYellow: () => import("./index122.mjs"),
  happyFaceBlue: () => import("./index123.mjs"),
  happyFacePink: () => import("./index124.mjs"),
  happyFaceYellow: () => import("./index125.mjs"),
  headphonesCustomer: () => import("./index126.mjs"),
  helpChatBlue: () => import("./index127.mjs"),
  helpChatPink: () => import("./index128.mjs"),
  helpChatYellow: () => import("./index129.mjs"),
  homeBlue: () => import("./index130.mjs"),
  homePink: () => import("./index131.mjs"),
  homeYellow: () => import("./index132.mjs"),
  hourGlassBlue: () => import("./index133.mjs"),
  hourGlassPink: () => import("./index134.mjs"),
  hourGlassYellow: () => import("./index135.mjs"),
  house: () => import("./index136.mjs"),
  imageModified: () => import("./index137.mjs"),
  informationCircle: () => import("./index138.mjs"),
  informationCircleInverted: () => import("./index139.mjs"),
  instagram: () => import("./index140.mjs"),
  interfaceAlertAlarmBellBlue: () => import("./index141.mjs"),
  interfaceAlertAlarmBellPink: () => import("./index142.mjs"),
  interfaceAlertAlarmBellYellow: () => import("./index143.mjs"),
  interfaceAwardTrophyBlue: () => import("./index144.mjs"),
  interfaceAwardTrophyPink: () => import("./index145.mjs"),
  interfaceAwardTrophyYellow: () => import("./index146.mjs"),
  interfaceCursorArrowBlue: () => import("./index147.mjs"),
  interfaceCursorArrowPink: () => import("./index148.mjs"),
  interfaceCursorArrowYellow: () => import("./index149.mjs"),
  interfaceFavoriteLikeBlue: () => import("./index150.mjs"),
  interfaceFavoriteLikePink: () => import("./index151.mjs"),
  interfaceFavoriteLikeYellow: () => import("./index152.mjs"),
  interfaceImageVideoAudioSubtitlesBlue: () => import("./index153.mjs"),
  interfaceImageVideoAudioSubtitlesPink: () => import("./index154.mjs"),
  interfaceImageVideoAudioSubtitlesYellow: () => import("./index155.mjs"),
  interfaceLightingLightBulbBlue: () => import("./index156.mjs"),
  interfaceLightingLightBulbPink: () => import("./index157.mjs"),
  interfaceLightingLightBulbYellow: () => import("./index158.mjs"),
  interfaceSearchBlue: () => import("./index159.mjs"),
  interfaceSearchPink: () => import("./index160.mjs"),
  interfaceSearchYellow: () => import("./index161.mjs"),
  keyboardBlue: () => import("./index162.mjs"),
  keyboardPink: () => import("./index163.mjs"),
  keyboardYellow: () => import("./index164.mjs"),
  keyboardArrowRight: () => import("./index165.mjs"),
  layersBlue: () => import("./index166.mjs"),
  layersPink: () => import("./index167.mjs"),
  layersYellow: () => import("./index168.mjs"),
  layoutWindowBlue: () => import("./index169.mjs"),
  layoutWindowPink: () => import("./index170.mjs"),
  layoutWindowYellow: () => import("./index171.mjs"),
  linkedIn: () => import("./index172.mjs"),
  lock: () => import("./index173.mjs"),
  lockUnlock: () => import("./index174.mjs"),
  loginBlue: () => import("./index175.mjs"),
  loginPink: () => import("./index176.mjs"),
  loginYellow: () => import("./index177.mjs"),
  logoStoryblocks: () => import("./index178.mjs"),
  logoStoryblocksGray: () => import("./index179.mjs"),
  logoStoryblocksWhite: () => import("./index180.mjs"),
  maestro: () => import("./index181.mjs"),
  magicWandBlue: () => import("./index182.mjs"),
  magicWandPink: () => import("./index183.mjs"),
  magicWandYellow: () => import("./index184.mjs"),
  maker: () => import("./index185.mjs"),
  mastercard: () => import("./index186.mjs"),
  megaphoneBlue: () => import("./index187.mjs"),
  megaphonePink: () => import("./index188.mjs"),
  megaphoneYellow: () => import("./index189.mjs"),
  microphone: () => import("./index190.mjs"),
  microphoneOff: () => import("./index191.mjs"),
  moneyCashBillBlue: () => import("./index192.mjs"),
  moneyCashBillPink: () => import("./index193.mjs"),
  moneyCashBillYellow: () => import("./index194.mjs"),
  moneyWalletBlue: () => import("./index195.mjs"),
  moneyWalletPink: () => import("./index196.mjs"),
  moneyWalletYellow: () => import("./index197.mjs"),
  musicSound: () => import("./index198.mjs"),
  navigationMenuHorizontal: () => import("./index199.mjs"),
  navigationMenuVertical: () => import("./index200.mjs"),
  newStickyNoteBlue: () => import("./index201.mjs"),
  newStickyNotePink: () => import("./index202.mjs"),
  newStickyNoteYellow: () => import("./index203.mjs"),
  oneFingerTapBlue: () => import("./index204.mjs"),
  oneFingerTapPink: () => import("./index205.mjs"),
  oneFingerTapYellow: () => import("./index206.mjs"),
  openBookBlue: () => import("./index207.mjs"),
  openBookPink: () => import("./index208.mjs"),
  openBookYellow: () => import("./index209.mjs"),
  panelCollapse: () => import("./index210.mjs"),
  panelExpand: () => import("./index211.mjs"),
  paragraphLeftAlign: () => import("./index212.mjs"),
  paragraphsCenterAlign: () => import("./index213.mjs"),
  paragraphsRightAlign: () => import("./index214.mjs"),
  payPal: () => import("./index215.mjs"),
  penBlue: () => import("./index216.mjs"),
  penPink: () => import("./index217.mjs"),
  penYellow: () => import("./index218.mjs"),
  pencil: () => import("./index219.mjs"),
  picturesFolderMemoriesBlue: () => import("./index220.mjs"),
  picturesFolderMemoriesPink: () => import("./index221.mjs"),
  picturesFolderMemoriesYellow: () => import("./index222.mjs"),
  pinBlue: () => import("./index223.mjs"),
  pinPink: () => import("./index224.mjs"),
  pinYellow: () => import("./index225.mjs"),
  pinterest: () => import("./index226.mjs"),
  playListBlue: () => import("./index227.mjs"),
  playListPink: () => import("./index228.mjs"),
  playListYellow: () => import("./index229.mjs"),
  playVideo: () => import("./index230.mjs"),
  plus: () => import("./index231.mjs"),
  profileAvatar: () => import("./index232.mjs"),
  questionmark: () => import("./index233.mjs"),
  refresh: () => import("./index234.mjs"),
  screenTvBlue: () => import("./index235.mjs"),
  screenTvPink: () => import("./index236.mjs"),
  screenTvYellow: () => import("./index237.mjs"),
  scriptBlue: () => import("./index238.mjs"),
  scriptPink: () => import("./index239.mjs"),
  scriptYellow: () => import("./index240.mjs"),
  search: () => import("./index241.mjs"),
  searchSimilar: () => import("./index242.mjs"),
  settingMenu: () => import("./index243.mjs"),
  share: () => import("./index244.mjs"),
  shoppingCartBlue: () => import("./index245.mjs"),
  shoppingCartPink: () => import("./index246.mjs"),
  shoppingCartYellow: () => import("./index247.mjs"),
  snapchat: () => import("./index248.mjs"),
  stamp: () => import("./index249.mjs"),
  starFourSided: () => import("./index250.mjs"),
  stopwatchBlue: () => import("./index251.mjs"),
  stopwatchPink: () => import("./index252.mjs"),
  stopwatchYellow: () => import("./index253.mjs"),
  stripe: () => import("./index254.mjs"),
  sunCloudBlue: () => import("./index255.mjs"),
  sunCloudPink: () => import("./index256.mjs"),
  sunCloudYellow: () => import("./index257.mjs"),
  textBold: () => import("./index258.mjs"),
  textInputArea: () => import("./index259.mjs"),
  textItalic: () => import("./index260.mjs"),
  textStrikeThrough: () => import("./index261.mjs"),
  textStyle: () => import("./index262.mjs"),
  textUnderline: () => import("./index263.mjs"),
  thirdEye: () => import("./index264.mjs"),
  trash: () => import("./index265.mjs"),
  travelMapEarthBlue: () => import("./index266.mjs"),
  travelMapEarthPink: () => import("./index267.mjs"),
  travelMapEarthYellow: () => import("./index268.mjs"),
  twitter: () => import("./index269.mjs"),
  uploadBottom: () => import("./index270.mjs"),
  uploadCircleBlue: () => import("./index271.mjs"),
  uploadCirclePink: () => import("./index272.mjs"),
  uploadCircleYellow: () => import("./index273.mjs"),
  userCircleSingleBlue: () => import("./index274.mjs"),
  userCircleSinglePink: () => import("./index275.mjs"),
  userCircleSingleYellow: () => import("./index276.mjs"),
  userSingleBlue: () => import("./index277.mjs"),
  userSinglePink: () => import("./index278.mjs"),
  userSingleYellow: () => import("./index279.mjs"),
  venmo: () => import("./index280.mjs"),
  verticalSliderSquareBlue: () => import("./index281.mjs"),
  verticalSliderSquarePink: () => import("./index282.mjs"),
  verticalSliderSquareYellow: () => import("./index283.mjs"),
  videoEditPeel: () => import("./index284.mjs"),
  videoEditSplit: () => import("./index285.mjs"),
  videoModified: () => import("./index286.mjs"),
  view: () => import("./index287.mjs"),
  viewOff: () => import("./index288.mjs"),
  visa: () => import("./index289.mjs"),
  voiceMailBlue: () => import("./index290.mjs"),
  voiceMailPink: () => import("./index291.mjs"),
  voiceMailYellow: () => import("./index292.mjs"),
  volumeDown: () => import("./index293.mjs"),
  volumeLevelHighBlue: () => import("./index294.mjs"),
  volumeLevelHighPink: () => import("./index295.mjs"),
  volumeLevelHighYellow: () => import("./index296.mjs"),
  volumeMedium: () => import("./index297.mjs"),
  volumeOff: () => import("./index298.mjs"),
  volumeUp: () => import("./index299.mjs"),
  warningTriangle: () => import("./index300.mjs"),
  webcamVideoBlue: () => import("./index301.mjs"),
  webcamVideoPink: () => import("./index302.mjs"),
  webcamVideoYellow: () => import("./index303.mjs"),
  youtube: () => import("./index304.mjs")
}, t = /* @__PURE__ */ new Set([
  "arrowCursor",
  "blankCalendar",
  "businessStartup",
  "camera",
  "cameraVideo",
  "chatBubbleTypingOval",
  "chatTwoBubblesSquare",
  "circleClock",
  "dashboardGauge",
  "downloadSquare",
  "emptyClipboard",
  "erlenmeyerFlask",
  "graphPieChart",
  "gridRules",
  "happyFace",
  "helpChat",
  "home",
  "hourGlass",
  "interfaceAlertAlarmBell",
  "interfaceAwardTrophy",
  "interfaceCursorArrow",
  "interfaceFavoriteLike",
  "interfaceImageVideoAudioSubtitles",
  "interfaceLightingLightBulb",
  "interfaceSearch",
  "keyboard",
  "layers",
  "layoutWindow",
  "login",
  "magicWand",
  "megaphone",
  "moneyCashBill",
  "moneyWallet",
  "newStickyNote",
  "oneFingerTap",
  "openBook",
  "pen",
  "picturesFolderMemories",
  "pin",
  "playList",
  "screenTv",
  "script",
  "shoppingCart",
  "stopwatch",
  "sunCloud",
  "travelMapEarth",
  "uploadCircle",
  "userCircleSingle",
  "userSingle",
  "verticalSliderSquare",
  "voiceMail",
  "volumeLevelHigh",
  "webcamVideo"
]), p = {
  arrowCursor: ["blue", "pink", "yellow"],
  blankCalendar: ["blue", "pink", "yellow"],
  businessStartup: ["blue", "pink", "yellow"],
  camera: ["blue", "pink", "yellow"],
  cameraVideo: ["blue", "pink", "yellow"],
  chatBubbleTypingOval: ["blue", "pink", "yellow"],
  chatTwoBubblesSquare: ["blue", "pink", "yellow"],
  circleClock: ["blue", "pink", "yellow"],
  dashboardGauge: ["blue", "pink", "yellow"],
  downloadSquare: ["blue", "pink", "yellow"],
  emptyClipboard: ["blue", "pink", "yellow"],
  erlenmeyerFlask: ["blue", "pink", "yellow"],
  graphPieChart: ["blue", "pink", "yellow"],
  gridRules: ["blue", "pink", "yellow"],
  happyFace: ["blue", "pink", "yellow"],
  helpChat: ["blue", "pink", "yellow"],
  home: ["blue", "pink", "yellow"],
  hourGlass: ["blue", "pink", "yellow"],
  interfaceAlertAlarmBell: ["blue", "pink", "yellow"],
  interfaceAwardTrophy: ["blue", "pink", "yellow"],
  interfaceCursorArrow: ["blue", "pink", "yellow"],
  interfaceFavoriteLike: ["blue", "pink", "yellow"],
  interfaceImageVideoAudioSubtitles: ["blue", "pink", "yellow"],
  interfaceLightingLightBulb: ["blue", "pink", "yellow"],
  interfaceSearch: ["blue", "pink", "yellow"],
  keyboard: ["blue", "pink", "yellow"],
  layers: ["blue", "pink", "yellow"],
  layoutWindow: ["blue", "pink", "yellow"],
  login: ["blue", "pink", "yellow"],
  magicWand: ["blue", "pink", "yellow"],
  megaphone: ["blue", "pink", "yellow"],
  moneyCashBill: ["blue", "pink", "yellow"],
  moneyWallet: ["blue", "pink", "yellow"],
  newStickyNote: ["blue", "pink", "yellow"],
  oneFingerTap: ["blue", "pink", "yellow"],
  openBook: ["blue", "pink", "yellow"],
  pen: ["blue", "pink", "yellow"],
  picturesFolderMemories: ["blue", "pink", "yellow"],
  pin: ["blue", "pink", "yellow"],
  playList: ["blue", "pink", "yellow"],
  screenTv: ["blue", "pink", "yellow"],
  script: ["blue", "pink", "yellow"],
  shoppingCart: ["blue", "pink", "yellow"],
  stopwatch: ["blue", "pink", "yellow"],
  sunCloud: ["blue", "pink", "yellow"],
  travelMapEarth: ["blue", "pink", "yellow"],
  uploadCircle: ["blue", "pink", "yellow"],
  userCircleSingle: ["blue", "pink", "yellow"],
  userSingle: ["blue", "pink", "yellow"],
  verticalSliderSquare: ["blue", "pink", "yellow"],
  voiceMail: ["blue", "pink", "yellow"],
  volumeLevelHigh: ["blue", "pink", "yellow"],
  webcamVideo: ["blue", "pink", "yellow"]
};
function m(e, o) {
  let r = e;
  if (t.has(e)) {
    const i = p[e] || [], l = o || i[0];
    if (o && !i.includes(o))
      return console.error(
        'Invalid variant "' + o + '" for icon "' + e + '". Available variants: ' + i.join(", ")
      ), null;
    r = e + l.charAt(0).toUpperCase() + l.slice(1);
  } else o && console.warn('Icon "' + e + '" does not support variants. Ignoring variant "' + o + '".');
  return a[r] || null;
}
function n(e) {
  return t.has(e);
}
function u(e) {
  const o = p[e];
  return o ? o[0] : void 0;
}
export {
  u as getDefaultVariant,
  m as getIconImport,
  n as hasVariants
};
